/**
 * No Guilt Premium Theme - Main JavaScript
 */

(function() {
  'use strict';

  // Overlay toggle
  const overlay = document.querySelector('[data-overlay]');

  function showOverlay() {
    if (overlay) overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function hideOverlay() {
    if (overlay) overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  if (overlay) {
    overlay.addEventListener('click', hideOverlay);
  }

  // Expose functions globally
  window.theme = window.theme || {};
  window.theme.showOverlay = showOverlay;
  window.theme.hideOverlay = hideOverlay;

})();
